var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE9ListItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.65036L3.67319 0.09375H7.53236L11.2056 4.62712L5.3238 11.9037H1.48787L3.69644 9.18373L0 4.65036ZM5.6255 6.8126L7.3691 4.65053L5.60225 2.46521L3.8354 4.65053L5.6255 6.8126Z",
    fill: "url(#paint0_linear_3051_9746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3051_9746",
    x1: 1.86759,
    y1: 11.4963,
    x2: 13.3871,
    y2: 4.30921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED401"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE9ListItemIcon);
export default __webpack_public_path__ + "static/media/e9-list-item-icon.2f856a6b86653ba03cc6f54742de690e.svg";
export { ForwardRef as ReactComponent };